module.exports = __webpack_public_path__ + "img/stores.e4bfdc1a.svg";